import * as React from 'react'
import { InputProps, NormalizedProps } from './wrapperTypes'

const translateProps = (Comp: React.ComponentType<NormalizedProps>) => {
  const HOC = (inputProps: InputProps) => {
    const { data, id, autoPlay, ...otherProps } = inputProps

    if (!data) {
      return null
    }
    if (data?.length <= 0) {
      return null
    }
    const normalizedData = data.map(d => {
      const { id, ...props } = d
      return {
        campaign_id: d.id,
        props: props,
      }
    })

    return <Comp autoPlay={autoPlay} resource_id={id} data={normalizedData} {...otherProps} />
  }

  return HOC
}

export default translateProps
